import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useRealtimeDrivers } from 'Core/hooks';
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";

//Components
import {
    Breadcrumb,
    Container,
} from "@gpstrackit/gtc-react-controls";
import { Grid } from '@mui/material';

//Action
import {
    openModalEntityDetails,
    catalogLoad, 
} from 'Redux/actions';

//Views
import ScheduleTasksLogs from './.components/scheduleTasksLog';
import ScheduleTasks from './.components/scheduleTasks';

//Styles
import './styles.scss';
const DriverDetailView = (props) => {
    const { messages } = useIntl();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    let path = location.pathname.split("/");
    const id = path[path.length - 1];

    //Redux States
    const drivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });
    

    //Local States
    const [view, setView] = useState("scheduleTask");

    useEffect(() => {
        dispatch(catalogLoad(["contacts", "drivers", "driverGroups"]))
    }, [])

    const refreshTable = (newView) => {
        if (newView != view) setView(newView)
    }

    const handleDetails = (entityId, entityName, numberTab, title) => {
        dispatch(openModalEntityDetails({ open: true, entityId, entityName, numberTab, title }))
    }

    return (
        <Container className="container-view">
            <div className="driver-detail-breadcrumb-container">
                <Breadcrumb
                    links={[
                        {
                            title: messages["mainView_drivers"],
                            link: "/app/maintenance/main/2",
                        },
                        {
                            title: drivers.filter((e) => e?.driverId == id)[0]?.name,
                        },
                    ]}
                    navigate={navigate}
                />
            </div>
            <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                style={{ padding: 15 }}
            >
                <Grid item xs={12}>
                    {view === "scheduleTask" && (
                        <ScheduleTasks
                            handleDetails={handleDetails}
                            refreshTable={refreshTable}
                            view={view}
                        />
                    )}
                    {view === "scheduleTaskLog" && (
                        <ScheduleTasksLogs
                            handleDetails={handleDetails}
                            refreshTable={refreshTable}
                            view={view}
                        />
                    )}
                </Grid>
            </Grid>
        </Container>
    )
}

export default DriverDetailView;